<template>
	<div class="mx-3 full-width">
		<v-layout
			row
			wrap
			class="my-4 full-width auto-height pos-rel profile-card"
		>
			<img
				:src="userMod.coverPic"
				alt="cover"
				class="full-width full-cover cover-pic"
			/>
			<div class="top-right" style="z-index:3">
				<v-tooltip left v-if="isReported">
					<v-btn
						icon
						outline
						color="error"
						slot="activator"
						@click="removeCoverPic"
						:loading="removeCoverPicLoading"
					>
						<v-icon color="error">delete</v-icon>
					</v-btn>
					<span>Remove Cover Pic</span>
				</v-tooltip>
			</div>
			<v-layout
				row
				wrap
				class="pt-4 pb-3 px-5 background-gradient z-index--2"
			>
				<v-flex xs12 md3>
					<v-layout
						column
						class="full-width auto-height text-xs-center"
					>
						<v-flex xs12 class="mb-4">
							<v-avatar
								size="200px"
								class="pos-rel"
								@click="enlargeDpDrawer = true"
							>
								<img
									:src="userMod.pic"
									alt="dp"
									class="offset-thick-border"
									style="border-color:white;"
								/>
								<div
									v-if="userMod.userBanned && false"
									class="full-cover bg-graphics bg-full-size"
									style="background-image:url('/static/banned.png')"
								></div>
							</v-avatar>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 offset-md1 md8 class="white--text">
					<v-layout
						row
						wrap
						class="full-width auto-height"
						:class="{
							'mb-4': !singleColumnView,
							'mb-2': singleColumnView
						}"
					>
						<v-flex xs12 :class="{ 'text-xs-center': SM }">
							<h4 class="mb-2 display-1">
								{{ userMod.name }}
								<v-tooltip right v-if="isReported">
									<v-btn
										icon
										outline
										color="error"
										slot="activator"
										@click="removeName"
									>
										<v-icon color="error">delete</v-icon>
									</v-btn>
									<span>Remove Name</span>
								</v-tooltip>
								<v-avatar
									v-if="userMod.verifiedProfile"
									size="32px"
								>
									<img
										:src="
											`/static/badges/${_getVerifiedIcon(
												userMod
											)}.png`
										"
										alt="verify_status"
									/>
								</v-avatar>
								<br />
							</h4>
							<h5 class="mb-2 headline white--text">
								@{{ userMod.handle }}
							</h5>
							<h6 class="mb-0 title">
								{{ userMod.status }}
								<v-tooltip right v-if="isReported">
									<v-btn
										icon
										outline
										color="error"
										slot="activator"
										@click="removeStatus"
									>
										<v-icon color="error">delete</v-icon>
									</v-btn>
									<span>Remove Status</span>
								</v-tooltip>
							</h6>
						</v-flex>
					</v-layout>
					<v-layout
						row
						wrap
						class="full-width auto-height"
						:class="{
							'mb-2': !singleColumnView,
							'mb-3': singleColumnView
						}"
					>
						<v-flex xs4 md2 :class="{ 'text-xs-center': SM }">
							<h4
								class="mb-1"
								:class="{
									headline: singleColumnView,
									'display-1': !singleColumnView
								}"
							>
								{{ userMod.postCount }}
							</h4>
							<p class="mb-0 white--text">posts</p>
						</v-flex>
						<v-flex xs4 class="text-xs-center">
							<h4
								class="mb-1"
								:class="{
									headline: singleColumnView,
									'display-1': !singleColumnView
								}"
							>
								{{ userMod.follower }}
							</h4>
							<p class="mb-0 white--text">followers</p>
						</v-flex>
						<v-flex xs4 class="text-xs-center">
							<h4
								class="mb-1"
								:class="{
									headline: singleColumnView,
									'display-1': !singleColumnView
								}"
							>
								{{ userMod.following }}
							</h4>
							<p class="mb-0 white--text">following</p>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-layout>

		<v-flex xs12 offset-md4 md8>
			<v-layout row wrap class="full-width auto-height">
				<v-flex xs12 md8>
					<table class="full-width">
						<tbody>
							<tr v-for="(prop, i) in allValidProps" :key="i">
								<td class="text-xs-left pb-3">
									<v-icon class="mr-2">
										{{ prop.icon }}
									</v-icon>
									<b class="grey--text">{{ prop.text }}</b>
								</td>
								<td class="text-xs-left pb-3">
									<b class="grey--text text--darken-3">
										{{ userMod[prop.name] }}
									</b>
								</td>
							</tr>
						</tbody>
					</table>
					<v-layout
						v-if="
							showAppPerm &&
								permKeys.length &&
								userMod.appPermissions
						"
						row
						nowrap
						class="full-width auto-height text-xs-center mb-4 mx-0 divider-left"
					>
						<v-flex xs2 v-for="key in permKeys" :key="key">
							<v-icon>
								{{
									userMod.appPermissions[key]
										? "check_circle"
										: "cancel"
								}}
							</v-icon>
							<br />
							{{ key }}
						</v-flex>
					</v-layout>
					<a
						@click.stop.prevent="drawer = true"
						class="sorted-column"
					>
						<b>See full user data</b>
					</a>
				</v-flex>
			</v-layout>
		</v-flex>

		<v-dialog v-model="drawer" max-width="700" lazy>
			<code class="full-width pa-3 body-1 elevation-0 break-word">{{
				user
			}}</code>
		</v-dialog>

		<v-dialog v-model="enlargeDpDrawer" max-width="500" lazy>
			<div class="white">
				<img :src="userMod.pic" alt class="d-block hor-centered" />
			</div>
		</v-dialog>
	</div>
</template>

<script>
import * as utils from "@/utils";

export default {
	name: "AdvanceUserView",
	props: [
		"themeInputColor",
		"user",
		"userMod",
		"isReported",
		"allProps",
		"SM",
		"singleColumnView",
		"showAppPerm",
		"removeCoverPicLoading"
	],
	data() {
		return {
			drawer: false,
			enlargeDpDrawer: false,
			permKeys: []
		};
	},
	mounted() {
		this.setPermKeys(this.userMod);
	},
	computed: {
		allValidProps() {
			return this.allProps.filter(prop => prop.name in this.userMod);
		}
	},
	methods: {
		removeName() {
			this.$emit("REMOVE_PROFILE_INFO", "removeName");
		},
		removeStatus() {
			this.$emit("REMOVE_PROFILE_INFO", "removeStatus");
		},
		removeCoverPic() {
			this.$emit("REMOVE_PROFILE_INFO", "removeCoverPic");
		},
		_getVerifiedIcon(user) {
			return utils._getVerifiedIcon(user.verifiedProfile);
		},
		setPermKeys(newVal) {
			if (newVal.appPermissions) {
				this.permKeys = Object.keys(newVal.appPermissions);
			}
		}
	},
	watch: {
		userMod(newVal) {
			this.setPermKeys(newVal);
		}
	}
};
</script>

<style lang="scss" scoped>
.cover-pic {
	max-height: 100%;
	object-fit: cover;
	object-position: center;
}
.profile-card {
	overflow: hidden;
	border-radius: 24px;
}
.z-index--2 {
	z-index: 1;
}
.background-gradient {
	background: #483e3e80;
}
</style>
